<template>
  <SupportProgramDocumentGrid
    v-if="consumerProtocol.unserializedOptions?.protocol?.attachments?.length > 0"
    title="Ressources pour vous"
    description="Prenez connaissance des documents suivants pour conseiller au mieux votre patient"
    :attachments="consumerProtocol.unserializedOptions?.protocol?.attachments"
    :consumer="consumer"
  />
</template>

<script setup lang="ts">
import SupportProgramDocumentGrid from '@/program/components/support-program/SupportProgramDocumentGrid.vue';
import Customer from "@/customer/interfaces/Customer";
import Beneficiary from "@/customer/interfaces/Beneficiary";

defineProps<{ consumerProtocol: any; consumer: Customer | Beneficiary | undefined}>();
</script>
